import { Checkbox } from "@dash/form";
import { useTheme } from "@emotion/react";
import type { FC } from "react";

import { supportTicketReasonCategories } from "./supportTicketReasonCategories";

type Props = {
  selectedReasonIds: string[];
  onSelectedReasonIdsChange: (selectedReasonIds: string[]) => void;
};

export const SupportTicketReasonPickerContent: FC<Props> = ({ selectedReasonIds, onSelectedReasonIdsChange }) => {
  const theme = useTheme();

  const onReasonToggle = (reasonId: string, isSelected: boolean) => {
    if (isSelected) {
      onSelectedReasonIdsChange([...selectedReasonIds, reasonId]);
      return;
    }
    onSelectedReasonIdsChange(selectedReasonIds.filter((id) => id !== reasonId));
  };

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
      }}
    >
      {supportTicketReasonCategories.map((category) => (
        <div
          key={category.id}
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "0.625rem",
          }}
        >
          <div
            css={{
              color: theme.colors.primary,
              fontFamily: theme.displayFontFamily,
              fontWeight: 600,
              fontSize: "0.9375rem",
            }}
          >
            {category.label}
          </div>
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem", paddingLeft: "0.125rem" }}>
            {category.options.map((option) => (
              <Checkbox
                key={option.id}
                label={option.label}
                value={selectedReasonIds.includes(option.id)}
                onChange={(value) => onReasonToggle(option.id, value)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
